import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../../../../theme';

export const useFlightInformationSectionStyles = createStyles(({ token }) => ({
  flightInfoSection: {
    marginTop: 10,
    position: 'relative',

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: token.fontSize,
    },

    '.text-highlight': {
      color: token.colorPrimary,
    },
  },
  transparentTitle: {
    opacity: 0.5,
  },
  flightSectionHeader: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 700,
    fontSize: token.fontSizeHeading4,

    [`@media (max-width: ${token.screenXLMax}px)`]: {
      fontSize: token.fontSize,
    },
  },
  badgeDateSection: {
    display: 'flex',
    alignItems: 'center',
  },
  badgeDateSectionTitle: {
    '&&': {
      margin: 0,
      color: ThemeColors.COLOR_GREY11,
      fontSize: token.fontSizeHeading3,
      fontFamily: ThemeFont.FONT_FAMILY6,

      [`@media (max-width: ${token.screenXLMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_LG_PLUS,
      },
    },
  },
}));
